import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';

@Pipe({
  name: 'booleanToYesNo'
})
export class BooleanToYesNoPipe implements PipeTransform {

  i18n = inject(I18nService);

  transform(value: boolean = false): string {
    if (value) {
      return this.i18n.i18nLng()['YES'];
    } else {
      return this.i18n.i18nLng()['NO'];
    }
  }

}
